'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _grid = require('../components/grid.directive');

var _grid2 = _interopRequireDefault(_grid);

var _user = require('../api/user.service');

var _user2 = _interopRequireDefault(_user);

var _entityView = require('../api/entity-view.service');

var _entityView2 = _interopRequireDefault(_entityView);

var _customer = require('../api/customer.service');

var _customer2 = _interopRequireDefault(_customer);

var _entityView3 = require('./entity-view.routes');

var _entityView4 = _interopRequireDefault(_entityView3);

var _entityView5 = require('./entity-view.controller');

var _assignToCustomer = require('./assign-to-customer.controller');

var _assignToCustomer2 = _interopRequireDefault(_assignToCustomer);

var _addEntityViewsToCustomer = require('./add-entity-views-to-customer.controller');

var _addEntityViewsToCustomer2 = _interopRequireDefault(_addEntityViewsToCustomer);

var _entityView6 = require('./entity-view.directive');

var _entityView7 = _interopRequireDefault(_entityView6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.entityView', [_angularUiRouter2.default, _grid2.default, _user2.default, _entityView2.default, _customer2.default]).config(_entityView4.default).controller('EntityViewController', _entityView5.EntityViewController).controller('EntityViewCardController', _entityView5.EntityViewCardController).controller('AssignEntityViewToCustomerController', _assignToCustomer2.default).controller('AddEntityViewsToCustomerController', _addEntityViewsToCustomer2.default).directive('tbEntityView', _entityView7.default).name;


// WEBPACK FOOTER //
// ./src/app/entity-view/index.js